export default {"src":"/flights/assets/desktop/_next/static/media/airplaneTop.391f3a9e.svg","height":16,"width":16};